import React from "react";
import styled from "@emotion/styled";
import { List } from "@mui/material";

import SidebarNavSection from "./SidebarNavSection";

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid ${(props) => props.theme.palette.divider};
  flex-grow: 1;
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

const SidebarNav = ({ items }) => {
  return (
    <Wrapper>
      {/* LWI-720 — the `<Box sx={{ mt: 3 }}>` that LWI-719 left here to
          preserve the PAGES-label spacing is dropped: the ToggleRow + its
          divider already provide the visual break above the menu, so
          24px of extra top margin just adds a visible gap. */}
      <List disablePadding>
        <Items>
          {items &&
            items.map((item) => (
              <SidebarNavSection
                component="div"
                key={item.title}
                pages={item.pages}
                title={null}
              />
            ))}
        </Items>
      </List>
    </Wrapper>
  );
};

export default SidebarNav;
